<div class="px-3 py-3">
  <div class="row justify-content-center">
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 self-align-center">
    <mat-card class="shadow">
      <h3 class="content-label-each">{{'pages.placeholders.CreateANewRetailerPricelist' | translate }}</h3>
      <form [formGroup]="createPricelistForm" (ngSubmit)="onSubmit()">
        <div class="row g-0 mt-2">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
            <h4 class="form-item-label">
              {{'pages.History.Pricelistname' | translate }} <span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [textMask]="{ mask: charMask, guide: false }"
                  placeholder="{{'pages.placeholders.EnterPricelistName' | translate }}"
                  formControlName="PricelistName"
                  required
                />
              </mat-form-field>
              <div *ngIf="f.PricelistName.touched && f.PricelistName.invalid">
                <div *ngIf="f.PricelistName.errors.required">
                  <mat-hint class="text-danger ms-2">
                    {{'pages.placeholders.PricelistNameisrequired' | translate }}</mat-hint
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0 mt-2">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              pages.newRetailer.copyFrom <i class="mi mi-file-copy"></i>
            </h4>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline">
                <mat-select
                  placeholder="{{ 'pages.placeholders.Selectpricelist' | translate }}"
                  formControlName="copyFrom"
                >
                <mat-option
                *ngFor="let Pricelist of Pricelists"
                [value]="Pricelist"
              >
                {{ Pricelist }}
              </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="f.copyFrom.touched && f.copyFrom.invalid">
                <div *ngIf="f.copyFrom.errors.required">
                  <mat-hint class="text-danger ms-2"> {{'pages.placeholders.Pricelistisrequired' | translate }}</mat-hint>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-footer mt-6">
          <ul class="list-inline text-center">
            <li class="list-inline-item">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="!createPricelistForm.valid"
                class="rounded-0"
              >
                <span translate class="translate">Create</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                class="rounded-0"
                (click)="onCancel()"
              >
                <span translate class="translate">pages.newRetailer.cancel</span>
              </button>
            </li>
          </ul>
        </div>
      </form>
    </mat-card>
  </div>
</div>
</div>
